import React, { FC } from 'react';

import { colorStyles, phraseStyles, textSizeStyles } from './styles.css';
import classNames from 'classnames';
import { PhrasePackName } from '../../../types';

export type PhraseProps = {
  packName: PhrasePackName;
  className?: string;
  size?: 'extraSmall' | 'small' | 'medium' | 'large';
};

const Phrase: FC<PhraseProps> = ({ packName, className, children, size = 'small' }) => (
  <div className={classNames(phraseStyles, textSizeStyles[size], colorStyles[packName], className)}>{children}</div>
);

export default Phrase;
